import { render, staticRenderFns } from "./RowModificadorPrecio.vue?vue&type=template&id=2da64867"
import script from "./RowModificadorPrecio.vue?vue&type=script&lang=js"
export * from "./RowModificadorPrecio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports